import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { AccountRoutingModule } from './account-routing.module';
import { AccountTabsComponent } from './account-tabs/account-tabs.component';
import { FilesModule } from '../files/files.module';
import { RelatedSlaveAccountsComponent } from '../related-slave-accounts/related-slave-accounts.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { SharedModule } from '../shared/shared.module';
import { AccountTagsComponent } from './account-tags/account-tags.component';
import { AccountTagsEditComponent } from './account-tags-edit/account-tags-edit.component';
import { AccountTagsViewComponent } from './account-tags-view/account-tags-view.component';
import { AccountTagsFilterComponent } from './account-tags-filter/account-tags-filter.component';
import { NotificationRolesComponent } from './notification-roles/notification-roles/notification-roles.component';
import {
  NotificationRolesEditComponent
} from './notification-roles/notification-roles-edit/notification-roles-edit.component';
import {
  NotificationRolesSitesComponent
} from './notification-roles/notification-roles-sites/notification-roles-sites.component';
import {
  NotificationRolesUsersComponent
} from './notification-roles/notification-roles-users/notification-roles-users.component';
import {
  NotificationRolesTabsComponent
} from './notification-roles/notification-roles-tabs/notification-roles-tabs.component';
import {
  NotificationRolesSelectorComponent
} from './notification-roles/notification-roles-selector/notification-roles-selector.component';
import { RbacRolesComponent } from './rbac-roles/rbac-roles/rbac-roles.component';
import { RbacRolesSelectorComponent } from './rbac-roles/rbac-roles-selector/rbac-roles-selector.component';
import { RbacRolesEditComponent } from './rbac-roles/rbac-roles-edit/rbac-roles-edit.component';
import { RbacRolesTabsComponent } from './rbac-roles/rbac-roles-tabs/rbac-roles-tabs.component';
import { RbacRolesUsersComponent } from './rbac-roles/rbac-roles-users/rbac-roles-users.component';
import { RbacRolesFilterComponent } from './rbac-roles/rbac-roles-filter/rbac-roles-filter.component';
import {
  RbacPermissionsSelectorComponent
} from './rbac-roles/rbac-permissions-selector/rbac-permissions-selector.component';
import { AccountDocsComponent } from './account-docs/account-docs/account-docs.component';
import { AccountDocsEditComponent } from './account-docs/account-docs-edit/account-docs-edit.component';
import { AccountDocsLinksComponent } from './account-docs/account-docs-links/account-docs-links.component';
import { AccountDocsLinksEditComponent } from './account-docs/account-docs-links-edit/account-docs-links-edit.component';
import { AccountDocsLinksViewComponent } from './account-docs/account-docs-links-view/account-docs-links-view.component';
import { AccountDocsLayoutComponent } from './account-docs/account-docs-layout/account-docs-layout.component';
import { TemplateDocsModule } from '../template-docs/template-docs.module';
import { AccountRiskMatrixComponent } from './account-risk-matrix/account-risk-matrix.component';
import { AccountHierarchyOfControlsComponent } from './account-hierarchy-of-controls/account-hierarchy-of-controls.component';


@NgModule({
  declarations: [
    AccountDetailsComponent,
    AccountDocsComponent,
    AccountDocsEditComponent,
    AccountTabsComponent,
    AccountSettingsComponent,
    RelatedSlaveAccountsComponent,
    AccountTagsComponent,
    AccountTagsEditComponent,
    AccountTagsViewComponent,
    AccountTagsFilterComponent,
    AccountDocsLayoutComponent,
    AccountDocsLinksComponent,
    AccountDocsLinksEditComponent,
    AccountDocsLinksViewComponent,
    NotificationRolesComponent,
    NotificationRolesTabsComponent,
    NotificationRolesEditComponent,
    NotificationRolesSitesComponent,
    NotificationRolesUsersComponent,
    NotificationRolesSelectorComponent,
    RbacRolesComponent,
    RbacRolesSelectorComponent,
    RbacRolesEditComponent,
    RbacRolesTabsComponent,
    RbacRolesUsersComponent,
    RbacRolesFilterComponent,
    RbacPermissionsSelectorComponent,
    AccountRiskMatrixComponent,
    AccountHierarchyOfControlsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AccountRoutingModule,
    DirectivesModule,
    PipesModule,
    MatSelectModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatMenuModule,
    MatIconModule,
    MatListModule,
    MatDatepickerModule,
    MatTabsModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatBadgeModule,
    // The "Managed by" chip on partner roles in the RBAC roles list.
    MatChipsModule,
    FilesModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatCardModule,
    SharedModule,
    TemplateDocsModule,
    ReactiveFormsModule
  ],
  exports: [
    NotificationRolesSelectorComponent,
    RbacRolesSelectorComponent,
    // Exported for the super admin partner permission template (UsersPartnerComponent).
    RbacPermissionsSelectorComponent
  ]
})
export class AccountModule {}
